import React from "react";
import { Button, SxProps, Theme, CircularProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface ControlPanelButtonProps {
  label: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  icon?: React.ReactNode;
  disabled?: boolean;
  loading?: boolean;
  sx?: SxProps<Theme>;
}

const ControlPanelButton: React.FC<ControlPanelButtonProps> = ({
  label,
  onClick,
  icon,
  disabled = false,
  loading = false,
  sx = {},
}) => {
  const theme = useTheme();

  return (
    <Button
      variant="outlined"
      size="small"
      disabled={disabled || loading}
      onClick={onClick}
      startIcon={icon}
      sx={{
        px: "5px",
        minWidth: 0,
        fontSize: 12,
        fontWeight: 500,
        textTransform: "none",
        backgroundColor: "#f5f5f5",
        color: theme.custom.base.text.primary.light,
        borderColor: theme.custom.utility.divider.light,
        borderRadius: 0,
        boxShadow: "0px 1px 2px rgba(0,0,0,0.05)",
        "&:hover": {
          backgroundColor: "#f5f5f5b7",
        },
        "&.Mui-disabled": {
          opacity: 0.6,
        },
        ...sx,
      }}
    >
      <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
        {label}
        {loading && (
          <CircularProgress size={14} thickness={5} />
        )}
      </span>
    </Button>
  );
};

export default ControlPanelButton;
